module.exports = __webpack_public_path__ + "img/ao.aoae9767d.svg";